import { Pivot, PivotItem } from "@fluentui/react";
import DOMPurify from "dompurify";

import styles from "./AnalysisPanel.module.css";

import { SupportingContent } from "../SupportingContent";
import { AskResponse } from "../../api";
import { AnalysisPanelTabs } from "./AnalysisPanelTabs";

interface Props {
    className: string;
    activeTab: AnalysisPanelTabs;
    onActiveTabChanged: (tab: AnalysisPanelTabs) => void;
    activeCitation: string | undefined;
    citationHeight: string;
    answer: AskResponse;
    isDarkMode: boolean;
}

const pivotItemDisabledStyle = { disabled: true, style: { color: "grey" } };
const pivotItemEnabledStyleDark = {
    disabled: false,
    style: {
        color: "#ececf1",
        backgroundHovered: "rgba(0, 0, 0, 0)"
    }
};

export const AnalysisPanel = ({ answer, activeTab, activeCitation, citationHeight, className, onActiveTabChanged, isDarkMode }: Props) => {
    const isDisabledThoughtProcessTab: boolean = !answer.thoughts;
    const isDisabledSupportingContentTab: boolean = !answer.data_points.length;
    const isDisabledCitationTab: boolean = !activeCitation;

    const sanitizedThoughts = DOMPurify.sanitize(answer.thoughts!);

    return (
        <Pivot
            className={className}
            selectedKey={activeTab}
            onLinkClick={pivotItem => pivotItem && onActiveTabChanged(pivotItem.props.itemKey! as AnalysisPanelTabs)}
        >
            <PivotItem
                className={isDarkMode ? styles.pivotItemDark : undefined}
                itemKey={AnalysisPanelTabs.ThoughtProcessTab}
                headerText="Thought process"
                headerButtonProps={
                    isDarkMode
                        ? isDisabledThoughtProcessTab
                            ? pivotItemDisabledStyle
                            : pivotItemEnabledStyleDark
                        : isDisabledThoughtProcessTab
                        ? pivotItemDisabledStyle
                        : undefined
                }
            >
                <div className={isDarkMode ? styles.thoughtProcessDark : styles.thoughtProcess} dangerouslySetInnerHTML={{ __html: sanitizedThoughts }}></div>
            </PivotItem>
            <PivotItem
                itemKey={AnalysisPanelTabs.SupportingContentTab}
                headerText="Supporting content"
                headerButtonProps={
                    isDarkMode
                        ? isDisabledSupportingContentTab
                            ? pivotItemDisabledStyle
                            : pivotItemEnabledStyleDark
                        : isDisabledSupportingContentTab
                        ? pivotItemDisabledStyle
                        : undefined
                }
            >
                <SupportingContent supportingContent={answer.data_points} isDarkMode={isDarkMode} />
            </PivotItem>
            <PivotItem
                itemKey={AnalysisPanelTabs.CitationTab}
                headerText="Citation"
                headerButtonProps={
                    isDarkMode
                        ? isDisabledCitationTab
                            ? pivotItemDisabledStyle
                            : pivotItemEnabledStyleDark
                        : isDisabledCitationTab
                        ? pivotItemDisabledStyle
                        : undefined
                }
            >
                <iframe title="Citation" src={activeCitation} width="100%" height={citationHeight} />
            </PivotItem>
        </Pivot>
    );
};
